import React from 'react';
import { downloadAttachment } from '@/api/attachments';
import { FileTypeIcon } from '@/components/Icons/FileTypeIcon';
import type { MailAttachment } from '@/types/mail';
import {
  formatFileSize,
  getFileExtension,
  getFileType,
  isPreviewableInBrowser,
} from '@/utils/file';

interface Props {
  attachment: MailAttachment;
  onPreview: (attachment: MailAttachment) => void;
}

export const MailAttachmentCard: React.FC<Props> = ({
  attachment,
  onPreview,
}) => {
  const fileType = getFileType(attachment.name);
  const extension = getFileExtension(attachment.name);

  const handleClick = async () => {
    if (isPreviewableInBrowser(attachment.name)) {
      onPreview(attachment);
      return;
    }

    try {
      await downloadAttachment(attachment.id, attachment.name);
    } catch (error) {
      console.error('Attachment download failed', error);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-[76px] shrink-0 cursor-pointer flex-col items-start gap-2 text-left"
    >
      <FileTypeIcon type={fileType} className="size-[76px]" />
      <div className="flex w-full min-w-0 flex-col gap-0.5">
        <p className="w-full truncate text-caption-13 text-foreground">
          {attachment.name}
        </p>
        <p className="w-full truncate text-caption-12 text-subtle-foreground">
          {extension.toUpperCase()} {formatFileSize(attachment.sizeInBytes)}
        </p>
      </div>
    </button>
  );
};
